import React, { useState } from 'react';
import './ContectUs.css';
import { FaFacebookF, FaYoutube, FaTwitter } from 'react-icons/fa';

const ContectUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission (e.g., send email, save to DB)
        alert('Form submitted!');
        setFormData({ name: '', email: '', message: '' });
    };

    return (
        <>
            <div className="contectheadin">
                <div className="overlay"></div>
                <div className="contect-content">
                    <h1 className="contectheading">Contact Us</h1>
                </div>
            </div>

            <div className="contect-mission-section">
                <div className="contect-mission-text">
                    <div className="abcc">
                        <h2>Umrah Taxi Services</h2>
                    </div>
                    <p>
                        Greetings from the Umrah taxi service. We are committed to provide the most up-to-date information about Umrah taxi services. Our goal is to offer creative and environmentally friendly transportation options that make it easier for Muslims to travel for religious, academic, and cultural purposes.
                    </p>
                    <p>We value cooperation, respect, excellence, and services.</p>
                </div>
                
                <div className="contect-mission-image">
                    <h1>Contact Info</h1>
                    <div className="juststyle"></div>
                    <h3>Address​</h3>
                    <p>Makkah, Saudi Arabia</p>
                    <h3>Email Us</h3>
                    <p>umraahtaxiservices@gmail.com</p>
                    <h3>Call Us</h3>
                    <p>+923291396691</p>
                    <h3>Follow Us</h3>
                    <div className="social-icons">
                        <FaFacebookF style={{ fontSize: '30px', margin: '10px' }} />
                        <FaYoutube style={{ fontSize: '30px', margin: '10px' }} />
                        <FaTwitter style={{ fontSize: '30px', margin: '10px' }} />
                    </div>
                </div>
            </div>

            <div className="contact-form-section">
                <h2>Get in Touch</h2>
                <form onSubmit={handleSubmit} className="contact-form">
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Your Name"
                        required
                    />
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Your Email"
                        required
                    />
                    <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Your Message"
                        required
                    ></textarea>
                    <button type="submit">Send Message</button>
                </form>
            </div>

            <div className="map-section">
                <h2>Our Location</h2>
                <div className="google-map">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d116101.60422664677!2d39.81351150173888!3d21.422508288029037!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15650d78a539a1e3%3A0xa51e407b3e9b2406!2sMakkah%2C%20Saudi%20Arabia!5e0!3m2!1sen!2sus!4v1638502492584!5m2!1sen!2sus"
                        width="100%"
                        height="400"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                    ></iframe>
                </div>
            </div>
        </>
    );
};

export default ContectUs;
